import { render } from "./home.vue?vue&type=template&id=4bad5b0c&lang=pug"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/pages/home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bad5b0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bad5b0c', __exports__)) {
    api.reload('4bad5b0c', __exports__)
  }
  
  module.hot.accept("./home.vue?vue&type=template&id=4bad5b0c&lang=pug", () => {
    api.rerender('4bad5b0c', render)
  })

}


export default __exports__